import Header from '../Component/Header'
import Breadcrumb from "../Component/Breadcrumb";
import Footer from '../Component/Footer'
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
const booklist = ()=>{
    return(
        <> 
         <Header />
            <Breadcrumb title="BookList" mid="CBSE BOARD   &nbsp; &nbsp;|" tabName="BookList" />
            <div className="innerPage">
                <div className="container">
                    <div className="row">
                       <div className="col-lg-4 col-md-6">
                          <Link to="https://webapi.entab.info/api/image/NCSR/public/pdf/booklistclassItoIII.pdf" target="_blank">
                             <div className="sample-blk">
                                <p>Class I to III</p>
                                <LazyLoad> <img alt="NCSR" src="https://webapi.entab.info/api/image/NCSR/public/Images/pdf.png" className="img-fluid"/></LazyLoad>
                             </div> 
                         </Link>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <Link to="https://webapi.entab.info/api/image/NCSR/public/pdf/booklistclassIVtoXII.pdf" target="_blank">
                             <div className="sample-blk">
                                <p>Class IV to XII</p>
                                <LazyLoad> <img alt="NCSR" src="https://webapi.entab.info/api/image/NCSR/public/Images/pdf.png" className="img-fluid"/></LazyLoad>
                             </div> 
                         </Link>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default booklist;